import { ConfigurationModel, TroughModel } from 'franke-trough-dependencies';
import { FSA } from 'flux-standard-action';

export interface PlateBuilderPayload {
  configuration: ConfigurationModel;
  trough: TroughModel;
}

export enum PlateBuilderActions {
  Assign = '@plateBuilder/Assign',
  Clear = '@plateBuilder/Clear',
}

export const plateBuilder = {
  assign: (payload: PlateBuilderPayload): FSA<PlateBuilderActions.Assign, PlateBuilderPayload> => ({
    type: PlateBuilderActions.Assign,
    payload,
  }),
  clear: (): FSA<PlateBuilderActions.Clear, undefined> => ({
    type: PlateBuilderActions.Clear,
  }),
};